export default __webpack_public_path__ + "static/media/hub_inactive.873e0831.svg";